import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { getDoctorLinkedAgents } from '../../api/medics-api';
import GenericTable from '../tables/GenericTable';
import Pagination from '../layout/Pagination';
import Spinner from '../elements/Spinner/Spinner';

/**
 * A mentor's read-only view of the agents linked to them.
 */
const MentorLinkedAgents = ({ mentorId }) => {
  const [items, setItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);

  const loadAgents = useCallback(async () => {
    if (!mentorId) return;
    setLoading(true);
    const { data, success } = await getDoctorLinkedAgents(mentorId, {
      page: currentPage,
      limit: 10,
    });
    setLoading(false);
    if (!success) return;
    setItems(data?.items || []);
    setTotalPages(data?.totalPages || 1);
  }, [mentorId, currentPage]);

  useEffect(() => {
    loadAgents();
  }, [loadAgents]);

  const columns = [
    {
      key: 'firstName',
      label: 'Agent',
      render: (_, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    },
    { key: 'email', label: 'Email' },
    {
      key: 'referralCode',
      label: 'Referral kod',
      render: (val) => <span style={{ color: '#005844' }}>{val || '-'}</span>,
    },
    {
      key: 'status',
      label: 'Status',
      render: (val) => (
        <span className={val === 'ACTIVE' ? 'active' : 'inactive'}>
          {val === 'ACTIVE' ? 'Aktivan' : 'Deaktiviran'}
        </span>
      ),
    },
    {
      key: 'createdAt',
      label: 'Datum',
      render: (val) => (val ? dayjs(val).format('DD.MM.YYYY.') : '-'),
    },
  ];

  if (loading) {
    return <Spinner size="lg" />;
  }

  return (
    <div>
      <GenericTable
        data={items}
        columns={columns}
        emptyState={{
          icon: '/assets/icons/no-users.svg',
          title: 'Nema povezanih agenata',
        }}
      />
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      )}
    </div>
  );
};

MentorLinkedAgents.propTypes = {
  mentorId: PropTypes.string,
};

export default MentorLinkedAgents;
